<table class="table table-flush">
  <!--@if (items) {
    @if (containsChildren(items) || forceShowAsMultiLevelItem) {
      @for (group of items; track group.Id) {
        <thead class="bg-gray-{{ grayLevel }}">
          <tr>
            @if (showCollapseButton) {
              <th scope="col" class="pe-0" style="width: 30px">
                @if (group.Children.length > 0) {
                  <a (click)="toggleCollapse(group)">
                    <i
                      class="fa-solid {{
                        group.collapse ? 'fa-circle-chevron-right' : 'fa-circle-chevron-down'
                      }} text-secondary ms-1"
                      title="'{{ config.getDisplayName(group.instance) }}' toeklappen"
                    ></i>
                  </a>
                }
              </th>
            }
            <th scope="col">
              <!--TODO: multiple columns-->
  <!--
              <span>{{ config.getDisplayName(group.instance) }}</span>
            </th>
            <th scope="col" class="text-end" style="padding-right: 0.75rem">
              <div class="d-flex justify-content-end">
                <app-action-group
                  [actions]="config.customActions"
                  [row]="group.instance"
                ></app-action-group>
                <app-default-actions-group
                  [actions]="config.actions!"
                  [item]="group.instance"
                  [itemLabel]="config.itemLabel"
                  [itemName]="config.getDisplayName(group.instance)"
                  (addEvent)="addItemToGroup($event, group.instance)"
                  (moveEvent)="moveItem($event.action, $event.item, $event.direction)"
                  (deleteEvent)="removeItem($event)"
                  [isFirst]="$first"
                  [isLast]="$last"
                ></app-default-actions-group>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          @if (!group.collapse) {
            <tr>
              @if (showCollapseButton && showIndent) {
                <td></td>
              }
              <td
                [attr.colspan]="showCollapseButton && showIndent ? 2 : 3"
                style="
                  padding-top: 0rem !important;
                  padding-bottom: 0rem !important;
                  padding-right: 0rem !important;
                "
              >
                <app-multi-level-table
                  style="padding: 0 !important"
                  [showCollapseButton]="showCollapseButton"
                  [showIndent]="showIndent"
                  [level]="level + 1"
                  [config]="config"
                  [items]="group.Children"
                ></app-multi-level-table>
              </td>
            </tr>
          } @else {
            <tr>
              <td style="height: 2rem"></td>
              <td
                [attr.colspan]="showCollapseButton && showIndent ? 2 : 3"
                style="
                  padding-top: 0rem !important;
                  padding-bottom: 0rem !important;
                  padding-right: 0rem !important;
                "
              ></td>
            </tr>
          }
        </tbody>
      }
    } @else {
      <tbody>
        @for (item of items; track item.Id) {
          <tr
            app-table-row
            [columns]="config.columns"
            [item]="item.instance"
            [actions]="config.customActions"
            [defaultActions]="config.actions!"
            [itemLabel]="config.itemLabel"
            [itemName]="config.getDisplayName(item.instance)"
            (addEvent)="isMultiLevelItem(item) ? addItemToGroup($event, item.instance) : null"
            (moveEvent)="moveItem($event.action, $event.item, $event.direction)"
            (deleteEvent)="removeItem($event)"
            [isLast]="$last"
            [isFirst]="$first"
          ></tr>
        }
        @if (showAddInput) {
          <tr>
            <td [attr.colspan]="config.columns.length">
              <!--<input [formControl]="form.Name" type="text" class="form-control form-control-sm" placeholder="Kies een unieke benaming voor deze interesse...">
              <app-validator [control]="form.Name"></app-validator>--><!--
              <app-select
                [control]="addFormModel"
                [options]="addOptions"
                appendTo="body"
              ></app-select>
            </td>
            <td class="text-start pt-1">
              @if (addFormModel.value) {
                <a (click)="addSelectedToGroup()">
                  <i
                    class="fa-solid fa-circle-plus text-lg text-success align-middle me-2 pe-1"
                    title="Item toevoegen"
                  ></i>
                </a>
              } @else {
                <i
                  class="fa-regular fa-circle-plus text-lg align-middle me-2 pe-1 text-muted"
                  title="Item toevoegen"
                ></i>
              }
              <a (click)="showAddInput = false">
                <i class="fa-solid fa-xmark text-lg text-danger me-2 pe-1" title="Annuleren"></i>
              </a>
            </td>
          </tr>
        }
      </tbody>
    }
  }
  <!--TODO: loading animation + better loading check-->
</table>
<table class="table table-flush">
  @if (showHeaders) {
    <thead class="bg-gray-100">
      <tr>
        @if ((showIndent || showCollapseButton) && itemDepth > 0) {
          <th [attr.colspan]="showIndent ? itemDepth - 1 : 1"></th>
        }
        @for (column of config.columns; track column) {
          @if (column.colSpanTh ?? 1 > 0) {
            <th
              scope="col"
              [style.width]="column.width"
              [style.maxWidth]="column.maxWidth"
              [classList]="column.thClasses"
              [colSpan]="column.colSpanTh ?? 1"
            >
              {{ column.label }}
            </th>
          }
        }
        @if ((config.actions?.length ?? 0 > 0) || config.customActions.length > 0) {
          <th>
            <div class="d-flex justify-content-end align-items-center">
              @for (action of config.actions; track action.kind) {
                @if (action.kind === "add") {
                  <a (click)="openAddModal(action)">
                    <i
                      class="fa-solid fa-circle-plus text-lg text-success ms-3"
                      style="vertical-align: middle"
                      title="{{ config.itemLabel }} toevoegen"
                      style="vertical-align: middle"
                    ></i>
                  </a>
                }
              }
            </div>
          </th>
        }
      </tr>
    </thead>
  }
  <tbody>
    @for (group of items; track group.Id) {
      <app-table-group
        [config]="config"
        [isFirst]="$first"
        [isLast]="$last"
        [item]="group"
        (removeEvent)="removeItem($index)"
        (moveEvent)="moveItem($event.action, $event.item, $index, $event.direction)"
        (addEvent)="addItem()"
        [showCollapseButton]="showCollapseButton"
        [showIndent]="showIndent"
        [enableSelect]="enableSelect"
        [disableSelectButtons]="disableSelectButtons"
        [totalLevels]="colorDepth ?? itemDepth"
      ></app-table-group>
      <!--<ng-container
        *ngTemplateOutlet="
          tableGroup;
          context: { $implicit: group, isLast: $last, isFirst: $first }
        "
      ></ng-container>-->
    } @empty {}
  </tbody>
  @if (hasFooter()) {
    <tfoot>
      <tr class="bg-gray-{{ itemDepth > 5 ? 500 : itemDepth * 100 }}">
        @if ((showIndent || showCollapseButton) && itemDepth > 0) {
          <th [attr.colspan]="showIndent ? itemDepth - 1 : 1"></th>
        }
        @for (column of config.columns; track column) {
          @if (column.colSpanTh ?? 1 > 0) {
            <th
              scope="col"
              [style.width]="column.width"
              [style.maxWidth]="column.maxWidth"
              [classList]="column.thClasses"
              [colSpan]="column.colSpanTh ?? 1"
            >
              @if (column.footer) {
                @if (column.footer.template) {
                  <ng-container *ngTemplateOutlet="column.footer.template"></ng-container>
                } @else if (column.footer.format) {
                  <div [innerHTML]="column.footer.format(undefined)"></div>
                } @else if (column.footer.component) {
                  <ng-container
                    *ngComponentOutlet="
                      column.footer.component.component();
                      inputs: column.footer.component.componentInputs
                        ? column.footer.component.componentInputs(undefined)
                        : {};
                      ndcDynamicOutputs: column.footer.component.componentOutputds
                        ? column.footer.component.componentOutputs(undefined)
                        : {}
                    "
                  ></ng-container>
                }
              }
            </th>
          }
        }
        @if ((config.actions?.length ?? 0 > 0) || config.customActions.length > 0) {
          <th></th>
        }
      </tr>
    </tfoot>
  }
</table>

<!--ng-template #tableGroup let-group let-isLast="isLast" let-isFirst="isFirst">
  <tr
    app-table-row
    [columns]="config.columns"
    [actions]="config.customActions"
    [defaultActions]="config.actions!"
    [item]="group.instance"
    [itemLabel]="config.itemLabel"
    [itemName]="config.getDisplayName(group.instance)"
    (addEvent)="true ? addItemToGroup($event, group) : null"
    (moveEvent)="moveItem($event.action, $event.item, $event.direction)"
    (deleteEvent)="removeItem($event)"
    [isLast]="isLast"
    [isFirst]="isFirst"
  ></tr>
  @for (child of group.Children; track child) {
    <ng-container
      *ngTemplateOutlet="tableGroup; context: { $implicit: child, isLast: $last, isFirst: $first }"
    ></ng-container>
  }
</=ng-template>-->
